import { useEffect, useState } from "react";
import { UserService } from "../../../../services/UserService";

const clientLabel = (u) =>
  u.clientFullInfo?.companyName || [u.firstName, u.lastName].filter(Boolean).join(" ") || `Client #${u.userId}`;

export const useClientOptions = () => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    UserService.GetClientUsers().then((res) => {
      setOptions(
        (res || [])
          .map((u) => ({ value: u.userId, label: clientLabel(u) }))
          .sort((a, b) => a.label.localeCompare(b.label))
      );
      setLoading(false);
    });
  }, []);

  return { options, loading };
};
